export class IncidentCommentEditCommand {
    constructor(
        public readonly VarianceId: string,
        public readonly CommentId: string,
        public readonly CommentText: string,
        public readonly ModifiedBy: string,
    ) {}
}
